import { COLOR_PALETTE } from 'constants/ui';

export const bellButtonStyles = {
  minWidth: 'auto',
  padding: '8px',
  position: 'relative',
  marginLeft: 'auto',
  color: ({ palette }) => palette.common.white,

  '&:hover': {
    backgroundColor: ({ palette }) => palette.primary.dark,
  },

  '&[data-is-active="true"]': {
    backgroundColor: ({ palette }) => `${palette.primary.dark} !important`,
  },
};

export const badgeStyles = {
  '& .MuiBadge-badge': {
    backgroundColor: COLOR_PALETTE.RED[6],
    color: ({ palette }) => palette.common.white,
    minWidth: '20px',
    height: '20px',
    padding: '0 6px',
    right: 2,
    top: 2,
  },
};
